




import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { ModelEditableMixin } from "../../system/mixins";

@Component
export default class PatientFindDialogController extends Mixins(ModelEditableMixin) {
  @Prop()
  patientNo: string;

  @Prop()
  isVisible: boolean;

  @Watch("isVisible")
  onIsVisibleUpdated(newValue: boolean, oldValue: boolean) {
    if (newValue) {
      this.find();
    }
  }

  mounted(): void {
    if (this.isVisible) {
      this.find();
    }
  }

  private async find(): Promise<void> {
    const result = await this.$commonDialogs.patient.finder.show(null, false);
    if (result) {
      this.editingSource = result;
    }
  }
}
